<template>
  <div v-if="can('add-role')">
    <h2>Add Role</h2>

    <div class="custom-form">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <ValidationProvider name="name" rules="required" v-slot="{ errors }">
            <div class="form-group my-4">
              <label for="name">Name<Astrik /></label>
              <input
                type="text"
                v-model="name"
                class="form-control"
                id="title"
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <ValidationProvider
            name="guard_name"
            rules="required"
            v-slot="{ errors }"
          >
            <div class="form-group my-4">
              <label for="guard_name">Guard Name:</label>
              <input
                type="text"
                v-model="guard_name"
                class="form-control"
                id="slug"
                disabled
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <div class="button-form-group">
            <button type="submit" class="btn btn-success">Submit</button>
            <router-link
              class="text-decoration-none btn btn-danger pull-right"
              :to="{
                name: 'RoleList',
              }"
              >Cancel
            </router-link>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddRole",
  data() {
    return {
      submitting: false,
      name: "",
      guard_name: "api",
    };
  },

  methods: {
    onSubmit() {
      this.submitting = true;
      const formData = new FormData();
      formData.append("name", this.name);
      formData.append("guard_name", this.guard_name);

      this.$http
        .post("role", formData)
        .then((res) => {
          console.log(res.data);
          if (res.data.status == 1) {
            this.$notify({
              group: "notifications",
              title: "Role Added",
              type: "success",
              text: res.data.message,
            });
            this.$router.push({
              name: "RoleList",
            });
          } else {
            this.$notify({
              group: "notifications",
              title: res.data.message,
              type: "error",
              text: res.data.errors[0],
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>
